import * as muiLocales from '@mui/material/locale';
import type { Localization } from '@mui/material/locale';

// App codes are ISO 639-1 base; MUI ships region-suffixed bundles. Regional
// choices for ambiguous codes are deliberate: zh→Simplified (zhCN),
// pt→Brazilian (ptBR). Revisit if a partner needs zhTW/ptPT.
const MAP: Record<string, Localization> = {
  en: muiLocales.enUS,
  zh: muiLocales.zhCN,
  es: muiLocales.esES,
  fr: muiLocales.frFR,
  de: muiLocales.deDE,
  ja: muiLocales.jaJP,
  ko: muiLocales.koKR,
  pt: muiLocales.ptBR,
  it: muiLocales.itIT,
  vi: muiLocales.viVN,
};

export function getMuiLocale(code: string): Localization {
  return MAP[code] ?? muiLocales.enUS;
}
